<script setup>
import WootReports from './components/WootReports.vue';
</script>

<template>
  <WootReports
    key="inbox-reports"
    type="inbox"
    getter-key="inboxes/getInboxes"
    action-key="inboxes/get"
    header-icon="i-lucide-inbox"
    header-accent="cyan"
    :download-button-label="$t('INBOX_REPORTS.DOWNLOAD_INBOX_REPORTS')"
    :report-title="$t('INBOX_REPORTS.HEADER')"
    :report-subtitle="$t('INBOX_REPORTS.DESCRIPTION')"
  />
</template>
